import React from "react";
import { TreeItem } from "@mui/x-tree-view";
import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";
import { Icon, IconName } from "@formant/ui/component/common/Icon";
import { Typography } from "@formant/ui/component/common/Typography";

import { copyToClipboard } from "../common/copyToClipboard";

export interface ICopyableTreeNodeProps {
    itemId: string;
    label: string;
    badge?: string;
    icon?: IconName;
    copy?: boolean;
    children?: React.ReactNode;
}

export function CopyableTreeNode({
    itemId,
    label,
    badge,
    icon,
    copy,
    children,
}: ICopyableTreeNodeProps) {
    return (
        <TreeItem
            itemId={itemId}
            label={
                <InlineRow onClick={() => (copy ? copyToClipboard(label) : {})}>
                    {icon && (
                        <Icon name={icon} size="18" color={primary.silver} />
                    )}
                    <Typography type="list" color={primary.silver}>
                        {label}
                    </Typography>
                    {badge && (
                        <Badge>
                            <Typography type="minimum">{badge}</Typography>
                        </Badge>
                    )}
                </InlineRow>
            }
        >
            {children}
        </TreeItem>
    );
}

const Badge = styled.div(_ => ({
    display: "flex",
    marginLeft: "7px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "6.25rem",
    padding: "4px 8px 4px 8px",
    backgroundColor: `${primary.module}`,
    borderColor: `${primary.steel03}`,
    textAlign: "center",
}));

export const InlineRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.25rem;

    &:hover span {
        color: ${primary.white} !important;
    }

    & svg {
        margin-right: 5px;
    }
`;
